import { Star, StarFour } from 'phosphor-react';
import React from 'react';
import { HalfStar } from '../icons/common.icons';

interface RatingProps {
    company: string;
    rating: number; // The rating (like 4.9)
}

const Rating: React.FC<RatingProps> = ({ company, rating }) => {
    // Calculate full stars, half star, and empty stars
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

    return (
        <div className="row" style={{objectPosition:"center"}}>
            <div className="col-4">
                <img src={`/images/logos/${company.toLowerCase()}.svg`} alt={company} height="60px" />
            </div>
            <div className="col-6 flex-column">
                <span className="review-source">{company}</span>
                <div className="rating">
                    <span className={company.toLowerCase() === 'facebook' ? 'facebook-rating-text' : 'rating-text' }>{rating.toFixed(1)}</span>
                    <div className="star-container" id="star-rating">
                        {/* Render full stars */}
                        {[...Array(fullStars)].map((_, index) => (
                            // <div key={index} className="star full"></div>
                            <Star key={index} size={16} color='gold' weight='fill' fill='gold' />
                        ))}
                        {/* Render half star */}
                        {halfStar && 
                            // <div className="star half"></div>
                            <HalfStar className='half-star' />
                        }
                        {/* Render empty stars */}
                        {[...Array(emptyStars)].map((_, index) => (
                            // <div key={index} className="star empty"></div>
                            <Star key={index} size={16} color='lightgray' weight='fill' fill='lightgray' />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Rating;
